import { render } from "./RoleDetail.vue?vue&type=template&id=f8ca6b88&scoped=true&ts=true"
import script from "./RoleDetail.vue?vue&type=script&lang=ts"
export * from "./RoleDetail.vue?vue&type=script&lang=ts"

import "./RoleDetail.vue?vue&type=style&index=0&id=f8ca6b88&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8ca6b88"]])

export default __exports__